import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 621 120.77",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #6592fd;\n      }\n\n      .cls-2 {\n        fill: #090909;\n      }\n    " }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m391.08,16.25c-4.29,0-7.41-3.12-7.41-7.41s3.12-7.41,7.41-7.41,7.41,2.99,7.41,7.41-2.99,7.41-7.41,7.41Zm-5.85,77.85V26.51h11.7v67.58h-11.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m432.8,94.1l-24.43-67.58h12.74l18.45,54.32h.26l18.97-54.32h12.22l-24.95,67.58h-13.26Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m488.3,16.25c-4.29,0-7.41-3.12-7.41-7.41s3.12-7.41,7.41-7.41,7.41,2.99,7.41,7.41-2.99,7.41-7.41,7.41Zm-5.85,77.85V26.51h11.7v67.58h-11.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m507.41,26.51h12.48V8.32l11.7-2.34v20.54h20.02v9.62h-20.02v38.34c0,7.15,3.25,10.79,9.88,10.79,2.99,0,6.5-.78,9.75-2.08l1.95,9.1c-6.11,1.95-10.79,2.86-14.95,2.86-11.82,0-18.32-6.76-18.32-19.11v-39.9h-12.48v-9.62Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m595.27,96.44c-5.98,16.25-11.96,21.57-24.17,21.57-2.73,0-5.72-.26-8.71-.91l1.17-9.75c2.08.52,4.42.78,6.5.78,7.15,0,10.4-3.25,14.04-13.51l-25.73-68.1h12.61l18.84,52.63h.26l18.71-52.63h12.22l-25.73,69.92Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m55.23,94.1l-22.22-37.17H12.22v37.17H0V1.82h33.27c19.23,0,31.45,10.66,31.45,27.42,0,12.61-6.89,22.09-18.97,25.86l23.65,38.99h-14.17Zm-22.61-47.57c12.48,0,19.88-6.24,19.88-16.9s-7.28-16.89-19.62-16.89H12.22v33.79h20.4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m80.07,60.69c0-21.45,12.35-36,30.54-36s28.98,13.78,28.98,35.22v4.81h-47.57c1.3,13.65,8.58,21.31,20.27,21.31,6.89,0,13.52-2.73,19.5-8.19l5.46,8.45c-7.28,6.37-15.85,9.62-25.34,9.62-19.62,0-31.84-13.52-31.84-35.22Zm11.96-4.81h35.74c-.52-13.25-7.28-21.57-17.54-21.57s-17.68,8.71-18.19,21.57Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m190.02,10.66c-3.12-.52-5.2-.78-6.76-.78-7.15,0-10.92,4.03-10.92,11.44v5.2h16.51v9.62h-16.51v57.97h-11.7v-57.97h-12.48v-9.62h12.48v-5.85c0-13.26,7.41-20.67,20.79-20.67,2.86,0,6.63.39,9.62.91l-1.04,9.75Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m214.2,77.85c0,4.68,2.21,7.15,6.63,7.15,1.82,0,4.29-.39,6.5-1.17l1.17,9.23c-4.03,1.3-8.06,2.08-11.57,2.08-9.23,0-14.43-5.33-14.43-14.95V1.82h11.7v76.03Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "m237.08,60.69c0-21.45,12.35-36,30.54-36s28.98,13.78,28.98,35.22v4.81h-47.57c1.3,13.65,8.58,21.31,20.27,21.31,6.89,0,13.52-2.73,19.5-8.19l5.46,8.45c-7.28,6.37-15.85,9.62-25.34,9.62-19.62,0-31.84-13.52-31.84-35.22Zm11.96-4.81h35.74c-.52-13.25-7.28-21.57-17.54-21.57s-17.68,8.71-18.19,21.57Z"
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "m352.26,50.34l-7.15-9.85c6.19-10.31,18.58-16.81,28.77-13.05-4.71,2.18-8.91,5.68-12.18,9.91l-9.43,12.99Zm9.43,33.03l-9.46-13.04-7.15,9.86c6.19,10.32,18.59,16.87,28.8,13.09-4.71-2.18-8.91-5.68-12.18-9.91Zm-59.69-55.98c4.04,1.78,7.8,4.74,10.78,8.72,3.76,5.19,13.96,19.26,17.65,24.21-3.64,4.88-13.93,19.07-17.65,24.21-2.98,3.98-6.74,6.94-10.78,8.72,8.51,3.03,19.53-.84,25.08-8.72,4.41-6.08,13.26-18.3,17.65-24.21-1.07-1.45-6.12-8.29-7.05-9.6-8.72-12.22-18.01-28.99-35.68-23.32Z"
		})
	]
});
export default SvgLogoLight;
